import React from 'react';

import useProviders from '../hooks/useProviders';
import Error from '../pages/Error';
import providersService from '../services/providers';
import { AppConfig } from '../types/app';
import { IdProvider } from '../types/auth';

const WithProviders = ({
  children,
  config,
}: {
  children: ({ providers }: { providers: IdProvider[] }) => React.ReactNode;
  config: AppConfig;
}) => {
  let { providers, isLoading, error } = useProviders(config);

  if (isLoading) return null;

  if (error) {
    // Obs, below is a temporary solution to avoid any impact when switching over
    // to using the API instead of config. This will be replaced with rendering a
    // error message when the full switch to only using the API occurs.
    providers = providersService.getProvidersFromConfig(
      config,
      providersService.getClientId()
    );
  }

  if (!providers || !providers.length) {
    return (
      <Error
        config={config}
        details={'No providers has been enabled for the app client.'}
      />
    );
  }

  return <>{children({ providers })}</>;
};

export default WithProviders;
